import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    title: 'Fine Art Pet Portraits',
    data: {
      description: 'Turn your pet into a masterpiece. AI-generated fine art portraits in the style of Da Vinci, Van Gogh, Warhol and more — framed and delivered to your door.',
      canonical: 'https://theperfectmuse.com/',
    },
    loadComponent: () =>
      import('./landing/landing').then((m) => m.Landing),
  },
  {
    path: 'create',
    title: 'Create Your Portrait',
    data: {
      description: 'Upload a photo of your pet and choose an art style. Our AI generates a unique fine art portrait in minutes — ready to order as a framed print.',
      canonical: 'https://theperfectmuse.com/create',
    },
    loadComponent: () =>
      import('./generator/generator').then((m) => m.Generator),
  },
  {
    path: 'faq',
    title: 'Pet Portrait FAQ — Delivery, Framing & AI',
    data: {
      description: 'Questions about The Perfect Muse? Find answers on how our AI portraits work, framing options, delivery times, and what makes a great pet photo.',
      canonical: 'https://theperfectmuse.com/faq',
    },
    loadComponent: () =>
      import('./faq/faq').then((m) => m.Faq),
  },
  {
    path: 'photo-tips',
    title: 'How to Photograph Your Pet for the Best Portrait',
    data: {
      description: 'Get the best results from your AI pet portrait. Tips on lighting, angles, and composition to make sure your pet photo produces a stunning fine art print.',
      canonical: 'https://theperfectmuse.com/photo-tips',
    },
    loadComponent: () =>
      import('./photo-tips/photo-tips').then((m) => m.PhotoTips),
  },
  {
    path: 'returns',
    title: 'Returns & Refunds Policy',
    data: {
      description: 'Our returns and refunds policy for framed pet portrait prints. We want you to love your order — find out how we handle issues with your print.',
      canonical: 'https://theperfectmuse.com/returns',
    },
    loadComponent: () => import('./returns/returns').then((m) => m.Returns),
  },
  {
    path: 'terms',
    title: 'Terms & Conditions',
    data: {
      description: 'Terms and conditions for using The Perfect Muse and purchasing AI-generated framed pet portrait prints.',
      canonical: 'https://theperfectmuse.com/terms',
    },
    loadComponent: () => import('./terms/terms').then((m) => m.Terms),
  },
  {
    path: 'privacy',
    title: 'Privacy Policy',
    data: {
      description: 'How The Perfect Muse collects, uses, and protects your personal data when you use our service.',
      canonical: 'https://theperfectmuse.com/privacy',
    },
    loadComponent: () => import('./privacy/privacy').then((m) => m.Privacy),
  },
  {
    path: 'track',
    title: 'Track Your Order',
    data: {
      description: 'Track the status of your framed pet portrait print order from The Perfect Muse.',
      canonical: 'https://theperfectmuse.com/track',
    },
    loadComponent: () => import('./track/track').then((m) => m.Track),
  },
  {
    path: 'order/success',
    title: 'Order Confirmed',
    data: {
      canonical: 'https://theperfectmuse.com/order/success',
    },
    loadComponent: () =>
      import('./order-success/order-success').then((m) => m.OrderSuccess),
  },
  {
    path: 'unsubscribe',
    title: 'Unsubscribe',
    data: {
      canonical: 'https://theperfectmuse.com/unsubscribe',
    },
    loadComponent: () =>
      import('./unsubscribe/unsubscribe').then((m) => m.Unsubscribe),
  },
];
